import { useStateMachine } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../../_helpers/_methods';
import updateAction from './updateAction';
import { FormattedMessage } from 'react-intl';
import PriorityBar from '../Individual/Components/PriorityBar';
import NavigationButtonGroup from '../../../../admin/Events/Steps/components/NavigationButtonGroup';
import { useSelector } from 'react-redux';

function OrganizationStep3() {
  const lang = useSelector((state) => state?.local?.local);
  const rosterData = useSelector((state) => state.rosters.rosters);

  const [priorityData, setPriorityData] = useState([]);
  const [provincePriority, setProvincePriority] = useState([]);
  const { actions } = useStateMachine({ updateAction });
  const { state } = useStateMachine({ updateAction });
  const navigate = useNavigate();
  const { id, edit: isEdit } = useParams();
  const location = useLocation();
  const [defaultValue, setDefaultValue] = useState({});

  useEffect(() => {
    if (isEdit) {
      if (rosterData && Array.isArray(rosterData?.priorities)) {
        const obj = {};
        const ids = [
          'priority_first',
          'priority_second',
          'priority_third',
          'priority_fourth',
          'priority_fifth',
          'priority_sixth',
          'priority_seventh'
        ];
        rosterData.priorities.forEach((priority) => {
          obj[ids[priority.level]] = {
            ...priority,
            label: priority.province__title,
            value: priority.province__id
          };
        });
        setDefaultValue(obj);
        setValue(`priority_first`, obj?.priority_first);
        setValue(`priority_second`, obj?.priority_second);
        setValue(`priority_third`, obj?.priority_third);
        setValue(`priority_fourth`, obj?.priority_fourth);
        setValue(`priority_fifth`, obj?.priority_fifth);
        setValue(`priority_sixth`, obj?.priority_sixth);
        setValue(`priority_seventh`, obj?.priority_seventh);
      }
    }
  }, [rosterData]);

  useEffect(() => {
    state?.priority_first && setValue(`priority_first`, state?.priority_first);
    state?.priority_second && setValue(`priority_second`, state?.priority_second);
    state?.priority_third && setValue(`priority_third`, state?.priority_third);
    state?.priority_fourth && setValue(`priority_fourth`, state?.priority_fourth);
    state?.priority_fifth && setValue(`priority_fifth`, state?.priority_fifth);
    state?.priority_sixth && setValue(`priority_sixth`, state?.priority_sixth);
    state?.priority_seventh && setValue(`priority_seventh`, state?.priority_seventh);
  }, []);
  const handlePriorityChange = (e, priority, data) => {
    let restoreData = getValues(priority);

    if (restoreData) {
      restoreData ? data.push(restoreData) : '';

      // Way to create unique array
      // let s = new Set(arr);
      // let it = s.values();
      // return Array.from(it);
      data = data.filter((item) => item.value !== e.value);

      setProvincePriority(Array.from(new Set(data).values()));
      setValue(priority, e);
    } else {
      setValue(priority, e);

      data = data.filter((item) => item.value !== e.value);
      setProvincePriority(Array.from(new Set(data).values()));
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });
  const onSubmit = (data) => {
    actions.updateAction(data);
    let path = location.pathname.split('/');

    if (isEdit) {
      navigate(`/admin/rosters/organization/${id}/edit/4`);
    } else {
      path.includes('admin')
        ? navigate('/admin/rosters/organization_apply/4')
        : navigate('/rosters/organization_apply/4');
    }
  };

  useEffect(() => {
    state?.priority_first && setValue(`priority_first`, state?.priority_first);
    state?.priority_second && setValue(`priority_second`, state?.priority_second);
    state?.priority_third && setValue(`priority_third`, state?.priority_third);
    state?.priority_fourth && setValue(`priority_fourth`, state?.priority_fourth);
    state?.priority_fifth && setValue(`priority_fifth`, state?.priority_fifth);
    state?.priority_sixth && setValue(`priority_sixth`, state?.priority_sixth);
    state?.priority_seventh && setValue(`priority_seventh`, state?.priority_seventh);
    // setValue(`priority_first`, state?.priority_first);
    // setValue(`priority_second`, state?.priority_second);
    // setValue(`priority_third`, state?.priority_third);
    // setValue(`priority_fourth`, state?.priority_fourth);
    // setValue(`priority_fifth`, state?.priority_fifth);
    // setValue(`priority_sixth`, state?.priority_sixth);
    // setValue(`priority_seventh`, state?.priority_seventh);
  }, []);
  useEffect(() => {
    try {
      const getProvince = async () => {
        let res = await fetchWrapper.get('/province/');
        let temp = res.results;
        temp.push({
          title: 'कृपया प्रदेश छान्नुहोस्...',
          title_en: 'Please Select Province...',
          id: '400'
        });
        setPriorityData(temp);
      };
      getProvince();
    } catch (error) {
      ErrorMessageHandler(error);
    }
  }, []);

  useEffect(() => {
    let data = priorityData?.map((province) => ({
      label: lang === 'ne' ? province.title : province.title_en,
      value: province.id
    }));
    // data.push({ title: 'province', id: 'province' });
    setProvincePriority(data);
  }, [lang, priorityData]);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <div className="my-4">
            <h4 className="mb-4 pl-2">
              <FormattedMessage id="province_level_priority" />
            </h4>
          </div>
          <div className="row">
            <PriorityBar
              id="priority_first"
              titleId="1st_priority"
              handleChange={(e) => {
                handlePriorityChange(e, 'priority_first', provincePriority);
              }}
              provincePriority={provincePriority}
              defaultValue={defaultValue}
              state={state}
              register={register}
              error={errors}
            />
            <PriorityBar
              id="priority_second"
              titleId="2nd_priority"
              handleChange={(e) => {
                handlePriorityChange(e, 'priority_second', provincePriority);
              }}
              provincePriority={provincePriority}
              state={state}
              defaultValue={defaultValue}
              register={register}
              error={errors}
            />
            <PriorityBar
              id="priority_third"
              titleId="3rd_priority"
              handleChange={(e) => {
                handlePriorityChange(e, 'priority_third', provincePriority);
              }}
              provincePriority={provincePriority}
              state={state}
              defaultValue={defaultValue}
              register={register}
              error={errors}
            />
            <PriorityBar
              id="priority_fourth"
              titleId="4th_priority"
              handleChange={(e) => {
                handlePriorityChange(e, 'priority_fourth', provincePriority);
              }}
              provincePriority={provincePriority}
              state={state}
              defaultValue={defaultValue}
              register={register}
              error={errors}
            />
            <PriorityBar
              id="priority_fifth"
              titleId="5th_priority"
              handleChange={(e) => {
                handlePriorityChange(e, 'priority_fifth', provincePriority);
              }}
              provincePriority={provincePriority}
              state={state}
              defaultValue={defaultValue}
              register={register}
              error={errors}
            />

            <PriorityBar
              id="priority_sixth"
              titleId="6th_priority"
              handleChange={(e) => {
                handlePriorityChange(e, 'priority_sixth', provincePriority);
              }}
              provincePriority={provincePriority}
              state={state}
              defaultValue={defaultValue}
              register={register}
              error={errors}
            />
            <PriorityBar
              id="priority_seventh"
              titleId="7th_priority"
              handleChange={(e) => {
                handlePriorityChange(e, 'priority_seventh', provincePriority);
              }}
              provincePriority={provincePriority}
              state={state}
              defaultValue={defaultValue}
              register={register}
              error={errors}
            />
          </div>
        </div>
        <div className="">
          <hr />
          <NavigationButtonGroup
            backTo="/admin/rosters/organization_list"
            // showSubmit={id}
          />
        </div>
      </form>
    </div>
  );
}

export default OrganizationStep3;
